
'use strict';

module.exports = require('./src');



//////////////////
// WEBPACK FOOTER
// ./~/iframe-resizer/index.js
// module id = 1078
// module chunks = 0